"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widthWithMinMaxPropTypes = exports.widthPropTypes = exports.statusPropTypes = exports.spacingPropTypes = exports.readOnlyPropsTypes = exports.radiusPropTypes = exports.paddingPropTypes = exports.minWidthPropTypes = exports.marginPropTypes = exports.heightWithMinMaxPropTypes = exports.heightPropTypes = exports.formElementPropTypes = exports.fontPropTypes = exports.flexShrinkPropTypes = exports.flexPropTypes = exports.flexAttributesPropTypes = exports.displayPropTypes = exports.disabledPropTypes = exports.colorPropTypes = exports.borderPropTypes = exports.backgroundColorPropTypes = exports.aspectRatioPropTypes = exports.alignSelfPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _cssPropTypes = require("./cssPropTypes");
const aspectRatioPropTypes = exports.aspectRatioPropTypes = {
  aspectRatio: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'aspect-ratio' property for the element.")
};
const backgroundColorPropTypes = exports.backgroundColorPropTypes = {
  backgroundColor: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'background-color' property for the element.")
};
const borderPropTypes = exports.borderPropTypes = {
  border: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'border' property for the element.")
};
const colorPropTypes = exports.colorPropTypes = {
  color: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'color' property for the element.")
};
const radiusPropTypes = exports.radiusPropTypes = {
  borderRadius: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'border-radius' property for the element.")
};
const displayPropTypes = exports.displayPropTypes = {
  display: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'display' property for the element.")
};
const fontPropTypes = exports.fontPropTypes = {
  font: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'font-family' property for the element. Only supports named fonts from the Theme."),
  fontWeight: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'font-weight' property for the element. Only supports named font weights from the Theme."),
  fontSize: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'font-size' property for the element."),
  fontStyle: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'font-style' property for the element.")
};
const marginPropTypes = exports.marginPropTypes = {
  margin: (0, _cssPropTypes.cssMargin)().description("Sets the CSS 'margin' property for the element.")
};
const paddingPropTypes = exports.paddingPropTypes = {
  padding: (0, _cssPropTypes.cssPadding)().description("Sets the CSS 'padding' property for the element.")
};
const spacingPropTypes = exports.spacingPropTypes = {
  ...marginPropTypes,
  ...paddingPropTypes
};
const disabledPropTypes = exports.disabledPropTypes = {
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the user from interacting with the field.')
};
const readOnlyPropsTypes = exports.readOnlyPropsTypes = {
  readOnly: _stencilReactDesc.PropTypes.bool.description('Prevents the user from editing the content.')
};
const statusPropTypes = exports.statusPropTypes = {
  ...disabledPropTypes,
  warning: _stencilReactDesc.PropTypes.bool.description("Styles the field to indicate that it requires the user's attention."),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the field to indicate that the value is incorrect and cannot be used.')
};
const formElementPropTypes = exports.formElementPropTypes = {
  ...backgroundColorPropTypes,
  ...colorPropTypes,
  ...displayPropTypes,
  ...fontPropTypes,
  ...marginPropTypes,
  ...statusPropTypes
};
const flexPropTypes = exports.flexPropTypes = {
  flex: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'flex' property for the element.")
};
const flexShrinkPropTypes = exports.flexShrinkPropTypes = {
  flexShrink: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'flexShrink' property for the element.")
};
const alignSelfPropTypes = exports.alignSelfPropTypes = {
  alignSelf: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'align-self' property for the element.")
};
const flexAttributesPropTypes = exports.flexAttributesPropTypes = {
  ...flexPropTypes,
  ...alignSelfPropTypes,
  justifyContent: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'justify-content' property for the element."),
  alignItems: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'align-items' property for the element."),
  flexDirection: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-direction' property for the element."),
  flexWrap: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'flex-wrap' property for the element.")
};
const heightPropTypes = exports.heightPropTypes = {
  height: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'height' property for the element.")
};
const widthPropTypes = exports.widthPropTypes = {
  width: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'width' property for the element.")
};
const minWidthPropTypes = exports.minWidthPropTypes = {
  minWidth: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'min-width' property for the element.")
};
const widthWithMinMaxPropTypes = exports.widthWithMinMaxPropTypes = {
  ...widthPropTypes,
  ...minWidthPropTypes,
  maxWidth: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'max-width' property for the element.")
};
const heightWithMinMaxPropTypes = exports.heightWithMinMaxPropTypes = {
  ...heightPropTypes,
  minHeight: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'min-height' property for the element."),
  maxHeight: (0, _cssPropTypes.cssValue)().description("Sets the CSS 'max-height' property for the element.")
};